import axios from "axios";

//IMPORT API ROUTE URL
import { ADD_CERTIFICATION_ROUTE } from "./apiRoutes";

const addCertificate = (resource_slug, certification_title) => {
  var postData = new FormData();

  postData.append("certification_title", certification_title);
  postData.append("resource_slug", resource_slug);

  return axios
    .post(ADD_CERTIFICATION_ROUTE, postData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default addCertificate;
